// ONX Care brand and content constants
const PHONE_RAW = "905326014571";

const buildWaUrl = (text) =>
    `https://wa.me/${PHONE_RAW}?text=${encodeURIComponent(text)}`;

export const BRAND = {
    name: "ONX Care",
    tagline: "Profesyonel Temizlik Hizmetleri",
    locationShort: "Beşiktaş, İstanbul",
    locationLong: "Beşiktaş, İstanbul · Tüm İstanbul'a Hizmet",
    hours: "07:00 - 21:00 · Haftanın 7 Günü",
    phoneDisplay: "+90 532 601 45 71",
    phoneRaw: PHONE_RAW,
    email: "care@onxcare.com",
    // Default (generic) message used by header, hero, FAB, about, contact, footer
    whatsapp: buildWaUrl(
        "Merhaba ONX Care, temizlik hizmeti hakkında bilgi almak istiyorum.",
    ),
};

// Helper exposed for service-specific links
export const whatsappFor = (serviceName) =>
    buildWaUrl(
        `Merhaba ONX Care, ${serviceName} hizmeti hakkında bilgi almak istiyorum.`,
    );

export const SERVICES = [
    {
        id: "ev-temizligi",
        title: "Ev Temizliği",
        waText: "ev temizliği",
        short: "Detaylı, hijyenik, kusursuz.",
        description:
            "Mutfaktan banyoya, salondan yatak odasına kadar evinizin her köşesinde profesyonel detay temizliği.",
        image:
            "https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwcHJpc3RpbmUlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4MDQ5OTY5Nnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "ofis-temizligi",
        title: "Ofis Temizliği",
        waText: "ofis temizliği",
        short: "Verimli çalışma için pırıl pırıl ortam.",
        description:
            "Çalışanlarınızın motivasyonunu artıran, hijyenik ve düzenli ofis ortamları için periyodik temizlik çözümleri.",
        image:
            "https://images.pexels.com/photos/9300768/pexels-photo-9300768.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "arac-ici-temizligi",
        title: "Araç İçi Temizlik",
        waText: "araç içi temizlik",
        short: "Detaylı iç temizlik.",
        description:
            "Koltuk yıkamadan tavan döşemeye, plastik aksamdan cam parlatmaya kadar otomobiliniz showroom hissinde.",
        image:
            "https://images.pexels.com/photos/12959473/pexels-photo-12959473.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "cam-temizligi",
        title: "Cam Temizliği",
        waText: "cam temizliği",
        short: "Lekesiz, parlak, berrak.",
        description:
            "Konutlardan yüksek katlı binalara, vitrinlerden cephe camlarına; profesyonel ekipmanla iz bırakmayan temizlik.",
        image:
            "https://images.pexels.com/photos/37320179/pexels-photo-37320179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "kafe-restaurant",
        title: "Kafe & Restaurant",
        waText: "kafe & restaurant temizliği",
        short: "Hijyen standartlarında üst düzey temizlik.",
        description:
            "Mutfak, salon ve servis alanlarınızda sektörel hijyen normlarına uygun, sabah erken / gece geç temizlik servisleri.",
        image:
            "https://images.pexels.com/photos/8535635/pexels-photo-8535635.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "is-yeri-temizligi",
        title: "İş Yeri Temizliği",
        waText: "iş yeri temizliği",
        short: "Mağaza, AVM, ortak alanlar.",
        description:
            "Müşteri deneyimini kuvvetlendiren, marka imajınıza yakışır profesyonel ticari alan temizliği.",
        image:
            "https://images.unsplash.com/photo-1768270181430-3e3672a32283?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBsb2JieSUyMHByaXN0aW5lfGVufDB8fHx8MTc4MDQ5OTcwMnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "insaat-sonrasi",
        title: "İnşaat Sonrası Temizlik",
        waText: "inşaat sonrası temizlik",
        short: "Kaba pislikten ince detaya.",
        description:
            "Tadilat, dekorasyon ya da yeni yapı teslimi sonrası; çimento, boya ve toz kalıntılarından arındırılmış teslim hazır mekânlar.",
        image:
            "https://images.pexels.com/photos/20578678/pexels-photo-20578678.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
];

export const STATS = [
    { value: "500+", label: "Mutlu Müşteri" },
    { value: "7/24", label: "Esnek Randevu" },
    { value: "39", label: "İlçeye Hizmet" },
    { value: "%100", label: "Memnuniyet" },
];

export const VALUES = [
    {
        title: "Profesyonel Ekipman",
        desc: "Endüstriyel makineler, sertifikalı kimyasallar ve doğru ekipman seçimi ile lekesiz sonuç.",
    },
    {
        title: "Eğitimli Personel",
        desc: "Hijyen ve güvenlik prosedürleri konusunda eğitimli, üniformalı, kimlikli temizlik kadromuz.",
    },
    {
        title: "Şeffaf Fiyat",
        desc: "Ön ziyaret veya net brief sonrası size en uygun, açık ve net fiyat teklifi.",
    },
    {
        title: "Esnek Saatler",
        desc: "07:00 ile 21:00 arası, haftanın 7 günü, ihtiyacınıza göre randevu planlama.",
    },
];

export const PROCESS = [
    {
        step: "01",
        title: "Talep & Brief",
        desc: "WhatsApp veya telefonla bize ulaşın, ihtiyaçlarınızı dinleyelim.",
    },
    {
        step: "02",
        title: "Keşif & Teklif",
        desc: "Mekânınızı değerlendirir, şeffaf ve net bir fiyat sunarız.",
    },
    {
        step: "03",
        title: "Planlama",
        desc: "Size uygun gün ve saatte randevunuzu kesinleştiririz.",
    },
    {
        step: "04",
        title: "Temizlik & Teslim",
        desc: "Uzman ekibimiz pırıl pırıl bir mekân teslim eder.",
    },
];
